var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"440px"}},[_c('p',[_vm._v(_vm._s(_vm.$it("tip.bz")))]),_vm._v(" "),_c('OmsButton',{attrs:{"btn-config":_vm.btnConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }